module.exports = __webpack_public_path__ + "media/images/icons/sort_hover-20082a910a5a1ad7795a0a27f6ecb7cf.png";